import React from "react";

import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";

import white from "../../images/mana/white.png";
import blue from "../../images/mana/blue.png";
import red from "../../images/mana/red.png";
import green from "../../images/mana/green.png";
import black from "../../images/mana/black.png";

const MANA_IMAGES = {
   W: white,
   U: blue,
   B: black,
   R: red,
   G: green,
};

export default function StrixhavenSchool({
   iconWidth,
   school,
   sx,
   direction,
   spacing = 1,
   align = "center",
}) {
   const formatMana = (schoolString) => {
      if (schoolString != "null" && schoolString != "") {
         const mana = schoolString.split("(")[1]?.slice(0, -1);
         if (!mana) return [];

         return mana
            .split("/")
            .flatMap((part) => {
               const normalized = part.trim().toUpperCase();

               if (normalized.length === 2 && /^[WUBRG]{2}$/.test(normalized)) {
                  return normalized.split("");
               }

               return [normalized];
            })
            .filter((symbol) => MANA_IMAGES[symbol]);
      }
      return [];
   };

   const formatSchool = (schoolString) => {
      if (schoolString != "null" && schoolString != "") {
         const school = schoolString.split("(")[0];
         return school;
      } else {
         return [];
      }
   };

   return (
      <>
         {school && (
            <Stack
               direction={direction}
               alignItems='center'
               justifyContent={align}
               spacing={spacing}
               sx={{ ...sx }}
            >
               <Box>
                  {formatSchool(school)}
               </Box>

               <Stack
                  direction='row'
                  alignItems='center'
                  justifyContent={align}
                  spacing={0.5}
                  sx={{ ...sx }}
               >
                  {formatMana(school).map((icon, i) => (
                     <Box
                        sx={{
                           width: iconWidth,
                           height: iconWidth,
                        }}
                        key={"manaIcon-" + i + "-" + icon}
                     >
                        <img src={MANA_IMAGES[icon]} width='100%' alt={icon} />
                     </Box>
                  ))}
               </Stack>
            </Stack>
         )}
      </>
   );
}
